// This is the only HQ UI configuration boundary. Views and CSS are shared.
const first = window.location.pathname.split('/')[1];
const legacy = ({'floorball.danielfaldt.se':'floorball','hockeyhq.danielfaldt.se':'hockey'})[window.location.hostname];
const sport = ['floorball','hockey','football'].includes(first) ? first : legacy || 'floorball';
document.body.dataset.hqSport = sport;
const basename = first === 'matches' ? '/matches' : first === sport ? `/${sport}` : legacy === sport ? '' : `/${sport}`;
export const HQ = {
  sport, basename, brand:({floorball:'Floorball HQ',hockey:'Hockey HQ',football:'Football HQ'})[sport], label:({floorball:'Innebandy',hockey:'Hockey',football:'Fotboll'})[sport], capabilities:{lineups:sport !== 'football',players:sport !== 'football',live:sport !== 'football',notifications:sport !== 'football',favoritesSync:sport !== 'football',richShare:sport !== 'football'},
  api:`/${sport}/api`, dataApi:sport === 'floorball' ? '/floorball/api' : `/${sport}/api/hq`,
  storagePrefix:`${sport}-hq`,
  validFavorite:id => sport !== 'floorball' ? typeof id === 'string' && id.length <= 120 : Number.isInteger(id) && id > 0,
  favoriteBody:ids => sport === 'hockey' ? {team_names:ids} : {team_ids:ids},
  favoriteIds:data => data.team_ids || data.team_names || [],
  normalizeFavorites:data => ({...data,team_ids:data.team_ids || data.team_names || []}),
};
if (first === 'matches') HQ.brand = 'Sports HQ';
document.title = HQ.brand;
export const leagueCompetition = league => sport !== 'floorball' ? league?.key : league?.source_url?.match(/\/serie\/(\d+)\//)?.[1];
export const requestedHockeyMatch = params => sport === 'hockey' && params.get('simulation') && params.get('id')
  ? `hq://hockey/${params.get('simulation')}/${params.get('id')}/laguppstallning` : null;

// Preserve Hockey's existing deep-link query names alongside the shared HQ names.
if (sport !== 'floorball') {
  const query = new URLSearchParams(window.location.search);
  if (!query.has('serie') && query.has('simulation') && !window.location.pathname.endsWith('/match')) query.set('serie', query.get('simulation'));
  if (query.get('tab') === 'schedule') query.set('vy','spelschema');
  if (query.get('mine') === '1' && window.location.pathname.endsWith('/series')) query.set('mina','1');
  const search = query.toString();
  if (search !== window.location.search.slice(1)) window.history.replaceState(null,'',window.location.pathname+(search?'?'+search:'')+window.location.hash);
}

export const sportsimPath = path => (sport !== 'floorball' && path.startsWith('/matches?') ? `${HQ.dataApi}/sportsim` : `${HQ.api}/sportsim`) + path;
